var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import React from 'react';
export var AriaLiveAnnouncer = function (_a) {
    var id = _a.id, children = _a.children;
    return (React.createElement(ScreenReaderOnly, { className: "sr-only", id: "aria-live-announcer-".concat(id), "aria-live": "polite" }, children));
};
export var ScreenReaderOnly = styledWithTheme('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    border: 0;\n"], ["\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    border: 0;\n"])));
var templateObject_1;
